import React, { useState, useEffect } from 'react';
import '../css/donations.css'; // Reuse existing styling conventions
// import "../css/App.css";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const ShirtPage = () => {
    const [size] = useState('M');
    const [inventoryStatus, setInventoryStatus] = useState("In Stock"); // default
    const isOutOfStock = inventoryStatus === "Out of Stock";
    const isPreOrder = inventoryStatus === "Pre Order";

    const isUnavailable = isOutOfStock || isPreOrder;

    const subtitleText = isOutOfStock
        ? "Currently out of stock"
        : (isPreOrder ? "Pre-order unavailable" : "Limited edition");

    const buttonLabel = isOutOfStock
        ? "Out of Stock"
        : (isPreOrder ? "Pre-Order Unavailable" : "Purchase — $10.00");

    useEffect(() => {
        const fetchInventory = async () => {
            try {
                const ref = doc(db, "inventory", "T-Shirt");
                const snap = await getDoc(ref);
                if (snap.exists()) {
                    const data = snap.data() || {};
                    if (data.status) {
                        setInventoryStatus(data.status);
                    }
                }
            } catch (err) {
                console.error("Error loading shirt inventory", err);
            }
        };
        fetchInventory();
    }, []);

    const handlePurchase = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://us-central1-sole-15b6f.cloudfunctions.net/createStripeSession", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    isShirt: true,
                    shirtSize: size
                })
            });

            const data = await response.json();

            if (data.url) {
                window.location.href = data.url;
            } else {
                alert("Unable to create Stripe session.");
            }
        } catch (error) {
            console.error("Error starting Stripe checkout:", error);
            alert("There was a problem. Please try again later.");
        }
    };

    return (
        <div className="page-container fill-page donate-css">
            <Navbar />

            <div className="candle-holder">
                <div className="purchase-container">
                    {/* Left: product card */}
                    <section className="product-card">
                        <img
                            src="/shirt.png"
                            alt="AggieCAT shirt preview"
                            className="candle-image-large"
                        />

                        <div className="product-body">
                            <h1 className="candle-title">AggieCAT T-Shirt</h1>

                            <p className="candle-subtitle">
                                {subtitleText}
                            </p>

                            <p className="candle-price">$10.00</p>

                            <p className="candle-description">
                                Rep your faith and support SOLE with this limited edition AggieCAT tee.
                                Designed for comfort, boldness, and evangelization.
                            </p>
                        </div>
                    </section>

                    {/* Right: simple checkout card */}
                    <section className="checkout-card">
                        <h2 className="section-title">Order details</h2>

                        <div className="summary">
                            <div className={`summary-row ${isUnavailable ? 'muted' : ''}`}>
                                <span>AggieCAT T-Shirt</span>
                                <span>{isUnavailable ? 'Unavailable' : '$10.00'}</span>
                            </div>
                        </div>

                        <form onSubmit={handlePurchase} className="address-form">
                            <button
                                type="submit"
                                className="checkout-button"
                                disabled={isUnavailable}
                            >
                                {buttonLabel}
                            </button>

                            {isOutOfStock && (
                                <p className="pickup-warning">
                                    This shirt is currently out of stock. Please check back soon.
                                </p>
                            )}

                            {isPreOrder && !isOutOfStock && (
                                <p className="pickup-warning">
                                    This shirt is currently in pre-order status and is not available for purchase yet.
                                    Please check back once inventory is ready.
                                </p>
                            )}
                        </form>
                    </section>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ShirtPage;
